import ReactLoading from "react-loading";
import Backdrop from "@mui/material/Backdrop";
// import Redux
import {  useSelector } from 'react-redux';
import { RootState } from '../store/reducers';

export default function FreezScreen() {
    const state = useSelector((state: RootState) => state.waiter)
  return (
    <Backdrop
    sx={{ color: "#fff", zIndex: (theme:any) => theme.zIndex.drawer + 5 }}
    open={state.freezScreen} >
      <ReactLoading className="mx-auto" type="spin" color="#00000" />
    
    </Backdrop>
  );
}
